/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FolderSerializerLean } from './folderSerializerLean';

export interface DocumentSerializerNested {
  readonly id?: number;
  type?: DocumentSerializerNested.TypeEnum;
  category?: DocumentSerializerNested.CategoryEnum;
  folder: FolderSerializerLean;
  readonly file?: string;
  readonly filename?: string;
  readonly createdAt?: Date;
  readonly fileParsed?: string;
  /**
   * Return the file name as a spearate field.
   */
  readonly modes?: Array<DocumentSerializerNested.ModesEnum>;
  sourceUrl?: string;
}
export namespace DocumentSerializerNested {
  export type TypeEnum =
    | 'COMP'
    | 'ACTE'
    | 'TITRE'
    | 'EHYP'
    | 'CAD'
    | 'CAD-REDUIT'
    | 'RU'
    | 'PEB'
    | 'PEB_COMMUN'
    | 'DECOM'
    | 'CI'
    | 'REG'
    | 'ELEC'
    | 'BDES'
    | 'MAIN'
    | 'GARAN'
    | 'VENTE'
    | 'DEPOT'
    | 'BAIL'
    | 'CERTI'
    | 'OVAM'
    | 'CRED'
    | 'ACTE_CRED'
    | 'ACTE_MAND'
    | 'EH_COMPL'
    | 'EH_DEMANDE'
    | 'OTHER'
    | 'IBGE'
    | 'ARTICLE90'
    | 'COMP_SIGNE'
    | 'ACTE_MAIN'
    | 'OFFRE'
    | 'MAP'
    | 'WATERTOETS'
    | 'ASBEST'
    | 'REGISTER'
    | 'ERFGOED'
    | 'CRF'
    | 'RVV'
    | 'BCE'
    | 'PLAN_CAD'
    | 'DOC_SYNDIC'
    | 'ACTE_BASE'
    | 'ANNEX_BASE'
    | 'ETAT_LIEUX'
    | 'GARANTIE_LOC'
    | 'ACTE_HEREDITE'
    | 'DEMANDE_RU'
    | 'DECLA_SUCC'
    | 'PERMIS_URB'
    | 'PERMIS_ENV'
    | 'REG_BENEF'
    | 'MAATREGELEN'
    | 'AR_REC'
    | 'LETTRE_VENTE'
    | 'ANB'
    | 'SCHEMA_UNIF';
  export const TypeEnum = {
    COMP: 'COMP' as TypeEnum,
    ACTE: 'ACTE' as TypeEnum,
    TITRE: 'TITRE' as TypeEnum,
    EHYP: 'EHYP' as TypeEnum,
    CAD: 'CAD' as TypeEnum,
    CADREDUIT: 'CAD-REDUIT' as TypeEnum,
    RU: 'RU' as TypeEnum,
    PEB: 'PEB' as TypeEnum,
    PEBCOMMUN: 'PEB_COMMUN' as TypeEnum,
    DECOM: 'DECOM' as TypeEnum,
    CI: 'CI' as TypeEnum,
    REG: 'REG' as TypeEnum,
    ELEC: 'ELEC' as TypeEnum,
    BDES: 'BDES' as TypeEnum,
    MAIN: 'MAIN' as TypeEnum,
    GARAN: 'GARAN' as TypeEnum,
    VENTE: 'VENTE' as TypeEnum,
    DEPOT: 'DEPOT' as TypeEnum,
    BAIL: 'BAIL' as TypeEnum,
    CERTI: 'CERTI' as TypeEnum,
    OVAM: 'OVAM' as TypeEnum,
    CRED: 'CRED' as TypeEnum,
    ACTECRED: 'ACTE_CRED' as TypeEnum,
    ACTEMAND: 'ACTE_MAND' as TypeEnum,
    EHCOMPL: 'EH_COMPL' as TypeEnum,
    EHDEMANDE: 'EH_DEMANDE' as TypeEnum,
    OTHER: 'OTHER' as TypeEnum,
    IBGE: 'IBGE' as TypeEnum,
    ARTICLE90: 'ARTICLE90' as TypeEnum,
    COMPSIGNE: 'COMP_SIGNE' as TypeEnum,
    ACTEMAIN: 'ACTE_MAIN' as TypeEnum,
    OFFRE: 'OFFRE' as TypeEnum,
    MAP: 'MAP' as TypeEnum,
    WATERTOETS: 'WATERTOETS' as TypeEnum,
    ASBEST: 'ASBEST' as TypeEnum,
    REGISTER: 'REGISTER' as TypeEnum,
    ERFGOED: 'ERFGOED' as TypeEnum,
    CRF: 'CRF' as TypeEnum,
    RVV: 'RVV' as TypeEnum,
    BCE: 'BCE' as TypeEnum,
    PLANCAD: 'PLAN_CAD' as TypeEnum,
    DOCSYNDIC: 'DOC_SYNDIC' as TypeEnum,
    ACTEBASE: 'ACTE_BASE' as TypeEnum,
    ANNEXBASE: 'ANNEX_BASE' as TypeEnum,
    ETATLIEUX: 'ETAT_LIEUX' as TypeEnum,
    GARANTIELOC: 'GARANTIE_LOC' as TypeEnum,
    ACTEHEREDITE: 'ACTE_HEREDITE' as TypeEnum,
    DEMANDERU: 'DEMANDE_RU' as TypeEnum,
    DECLASUCC: 'DECLA_SUCC' as TypeEnum,
    PERMISURB: 'PERMIS_URB' as TypeEnum,
    PERMISENV: 'PERMIS_ENV' as TypeEnum,
    REGBENEF: 'REG_BENEF' as TypeEnum,
    MAATREGELEN: 'MAATREGELEN' as TypeEnum,
    ARREC: 'AR_REC' as TypeEnum,
    LETTREVENTE: 'LETTRE_VENTE' as TypeEnum,
    ANB: 'ANB' as TypeEnum,
    SCHEMAUNIF: 'SCHEMA_UNIF' as TypeEnum,
  };
  export type CategoryEnum =
    | 'AVANT_VENTE'
    | 'ACTES_TITRES'
    | 'HYPOTHECAIRES'
    | 'ADMIN_URBANISTIQUES'
    | 'CERTIFICATIONS'
    | 'FINANCIER'
    | 'CONTRATS'
    | 'CARTE_LOCALISATION'
    | 'IDENTITE'
    | 'AUTRE';
  export const CategoryEnum = {
    AVANTVENTE: 'AVANT_VENTE' as CategoryEnum,
    ACTESTITRES: 'ACTES_TITRES' as CategoryEnum,
    HYPOTHECAIRES: 'HYPOTHECAIRES' as CategoryEnum,
    ADMINURBANISTIQUES: 'ADMIN_URBANISTIQUES' as CategoryEnum,
    CERTIFICATIONS: 'CERTIFICATIONS' as CategoryEnum,
    FINANCIER: 'FINANCIER' as CategoryEnum,
    CONTRATS: 'CONTRATS' as CategoryEnum,
    CARTELOCALISATION: 'CARTE_LOCALISATION' as CategoryEnum,
    IDENTITE: 'IDENTITE' as CategoryEnum,
    AUTRE: 'AUTRE' as CategoryEnum,
  };
  export type ModesEnum = 'COMPROMIS' | 'VENTE' | 'CREDIT' | 'MANDAT_HYPO' | 'MAIN_LEVEE';
  export const ModesEnum = {
    COMPROMIS: 'COMPROMIS' as ModesEnum,
    VENTE: 'VENTE' as ModesEnum,
    CREDIT: 'CREDIT' as ModesEnum,
    MANDATHYPO: 'MANDAT_HYPO' as ModesEnum,
    MAINLEVEE: 'MAIN_LEVEE' as ModesEnum,
  };
}
